import React, {useEffect, useLayoutEffect, useState, memo} from "react";
import { useTranslation } from 'react-i18next';
import {useHistory} from "react-router-dom";
import {useForm} from "react-hook-form";

// Components
import LoadingSpinner from "sharedComponents/LoadingSpinner";

// Hooks
import useNotification from "Hooks/useNotification";

// Utils
import {auth} from "models/auth";

// Contexts
import {useAuth} from "context/auth.js";

const ResetPassword = ({token, email}) => {
    const history = useHistory();
    const resetPasswordSuccessNote = useNotification;
    const {removeAuthTokens} = useAuth();
    const [isCounterVisible, SetIsCounterVisible] = useState(false);
    const [timer, SetTimer] = useState(3);
    const { t } = useTranslation();
    const {handleSubmit, register, errors, getValues} = useForm();

    let timerInterval = null;

    useLayoutEffect(() => {
        removeAuthTokens();
        // eslint-disable-next-line
    }, []);

    const submitForm = async (data) => {
        try {
            const sendData = {
                ...data,
                token,
                email,
            };

            const {data: responseData} = await auth.resetPassword(sendData);

            if (responseData?.success) {
                SetIsCounterVisible(responseData.success);
                resetPasswordSuccessNote(
                    'success',
                    t('Password reset'),
                    responseData.message
                );
                timerInterval = setInterval(() => {
                    SetTimer((prevState) => prevState - 1);
                }, 1000);
            }
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        if (timer === 0) {
            clearInterval(timerInterval);
            history.push(`${process.env.REACT_APP_URL_PREFIX}/login`);
        }
        // eslint-disable-next-line
    }, [timer]);


    return (
        <form className="login_form reset_password_form" onSubmit={handleSubmit(submitForm)}>
            <h2 className="login_title">{t("Reset password")}</h2>
            <div className={`form_item ${errors.password ? "invalid" : ""}`}>
                <label htmlFor="password">{t("Password")}</label>
                <input
                    ref={register({
                        required: t("Required"),
                        validate: (value) => value.length >= 8 || t('At least 8 characters needed'),
                    })}
                    id="password"
                    name="password"
                    type="password"
                    placeholder={t("Enter your password")}
                    className="login_input"
                />
                <div className="error_sect">
                    {errors.password && t(errors.password.message)}
                </div>
            </div>
            <div className={`form_item ${errors.password_confirmation ? "invalid" : ""}`}>
                <label htmlFor="password_confirmation">{t("Password confirmation")}</label>
                <input
                    ref={register({
                        required: t("Required"),
                        validate: (value) => value === getValues().password || t('Passwords do not match')
                    })}
                    id="password_confirmation"
                    name="password_confirmation"
                    type="password"
                    placeholder={t("Confirm password")}
                    className="login_input"
                />
                <div className="error_sect">
                    {errors.password_confirmation && t(errors.password_confirmation.message)}
                </div>
            </div>
            <div className="login_actions">
                <button
                    type="submit"
                    className="primary_action"
                >
                    {t("Reset")}
                </button>
                {isCounterVisible && <p className="redirect_message">
                    <LoadingSpinner size="small"/>
                    <span className="redirect_message_content">{t("You Will be redirected after")} {timer} {t("seconds")}</span>
                </p>}
            </div>
        </form>
    );
};

export default memo(ResetPassword);